import "./index.css";

import fullLogo from "./logo-full.svg";

export function App() {
  return (
    <div className="w-full h-screen flex justify-center items-center text-center relative z-10">
      <img
        src={fullLogo}
        alt="Logo"
        className="w-full"
      />
    </div>
  );
}

export default App;
